// Libs
import { StyleSheet, Text, View } from '@react-pdf/renderer';
// Components, Layouts, Pages
// Others
import { EMPTY_STRING } from '~/utils/constants/common';
import { DateFormatEnum } from '~/utils/enum/common';
import { formatDate } from '~/utils/helper/common';
// Styles, images, icons

type Props = {
  title: string;
  titleDate?: string;
  id?: string;
  date?: string;
};

const HeaderPdf = (props: Props) => {
  //#region Destructuring Props
  const { title, titleDate, id, date } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function

  return (
    <View style={styles.container}>
      <View style={styles.viewText}>
        <Text style={styles.title}>{title}</Text>
        <Text style={styles.titleId}>{`#${id}`}</Text>
      </View>
      <View style={styles.viewText}>
        <Text style={styles.titleDate}>{titleDate}</Text>
        <Text style={styles.date}>{date ? formatDate(date, DateFormatEnum.MM_DD_YYYY) : EMPTY_STRING}</Text>
      </View>
    </View>
  );
};

export default HeaderPdf;

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    gap: 5,
  },

  viewText: {
    flexDirection: 'row',
    gap: 5,
  },

  title: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#2A3962',
  },

  titleId: {
    fontSize: 16,
    color: '#2A3962',
  },

  titleDate: {
    fontSize: 12,
    fontWeight: 'bold',
    color: '#2A3962',
  },

  date: {
    fontSize: 12,
    color: '#2A3962',
  },
});
